import { createApiAction } from '@app/packages/api/utils'
import type { V3GetCalendarFeedResponse, V3PostCalendarFeedResetResponse, V3PostCalendarFeedResponse } from '@app/packages/api/v3/types/responses'

export const getCalendarFeed = () =>
  createApiAction('getCalendarFeed', dispatch =>
    dispatch<V3GetCalendarFeedResponse>({
      endpoint: '/api/v3/calendar_feed',
      method: 'GET',
    })
  )

export const postCalendarFeed = () =>
  createApiAction('postCalendarFeed', dispatch =>
    dispatch<V3PostCalendarFeedResponse>({
      endpoint: '/api/v3/calendar_feed',
      method: 'POST',
    })
  )

export const postCalendarFeedReset = () =>
  createApiAction('postCalendarFeedReset', dispatch =>
    dispatch<V3PostCalendarFeedResetResponse>({
      endpoint: '/api/v3/calendar_feed/reset',
      method: 'POST',
    })
  )
